var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9809 0.332766C10.7979 0.515792 10.7979 0.815272 10.9809 0.998298L20.8272 10.8446L0.665501 10.8412C0.405952 10.8479 0.199653 11.0608 0.202991 11.317C0.209636 11.57 0.412628 11.7729 0.665532 11.7796L20.8272 11.7829L10.981 21.6291C10.7979 21.8121 10.7979 22.1116 10.9809 22.2947C11.164 22.4777 11.4634 22.4777 11.6465 22.2947L22.2947 11.6465C22.4777 11.4634 22.4777 11.164 22.2947 10.9809L11.6465 0.332766C11.4634 0.14974 11.164 0.14974 10.9809 0.332766Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.17647
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.52b67061f3bd17d163730f1375bbd4e7.svg";
export { ForwardRef as ReactComponent };